import React from 'react';
import { EvaluationItem } from '../../../../types/recruiter';

interface CustomSkillsSectionProps {
  customSkills: {
    skill_1?: EvaluationItem;
    skill_2?: EvaluationItem;
    skill_3?: EvaluationItem;
    total?: number;
  };
}

export const CustomSkillsSection: React.FC<CustomSkillsSectionProps> = ({
  customSkills,
}) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h4 className="text-lg font-semibold text-gray-900 mb-4">カスタムスキル</h4>
      <div className="space-y-4">
        {/* skill_1 */}
        {customSkills.skill_1 && (
          <div className="bg-gray-50 rounded-lg p-4">
            <h5 className="font-medium text-gray-900 mb-2">
              {customSkills.skill_1.title || 'カスタム評価1'}
            </h5>
            {customSkills.skill_1.evaluation && (
              <div className="text-sm text-gray-700 whitespace-pre-line">
                {customSkills.skill_1.evaluation}
              </div>
            )}
          </div>
        )}
        {/* skill_2 */}
        {customSkills.skill_2 && (
          <div className="bg-gray-50 rounded-lg p-4">
            <h5 className="font-medium text-gray-900 mb-2">
              {customSkills.skill_2.title || 'カスタム評価2'}
            </h5>
            {customSkills.skill_2.evaluation && (
              <div className="text-sm text-gray-700 whitespace-pre-line">
                {customSkills.skill_2.evaluation}
              </div>
            )}
          </div>
        )}
        {/* skill_3 */}
        {customSkills.skill_3 && (
          <div className="bg-gray-50 rounded-lg p-4">
            <h5 className="font-medium text-gray-900 mb-2">
              {customSkills.skill_3.title || 'カスタム評価3'}
            </h5>
            {customSkills.skill_3.evaluation && (
              <div className="text-sm text-gray-700 whitespace-pre-line">
                {customSkills.skill_3.evaluation}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
